import { render, staticRenderFns } from "./dashboardItem.vue?vue&type=template&id=05a5bff2&"
import script from "./dashboardItem.vue?vue&type=script&lang=js&"
export * from "./dashboardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports